/**
 * Body of a new version deposit: `multipart/form-data`, a `file` field and, when at least one section
 * is marked, `reevaluationSectionKeys` as JSON text (multipart has no array type).
 */
class UploadDocumentTemplateVersion {
	constructor(
		public readonly organizationId: number,
		public readonly templateId: number,
		public readonly file: File,
		public readonly reevaluationSectionKeys: readonly string[] = [],
	) {
		Object.freeze(this);
	}

	toFormData(): FormData {
		const formData = new FormData();
		formData.append('file', this.file);

		if (this.reevaluationSectionKeys.length > 0) {
			formData.append('reevaluationSectionKeys', JSON.stringify(this.reevaluationSectionKeys));
		}

		return formData;
	}
}

export default UploadDocumentTemplateVersion;
